import { render, staticRenderFns } from "./Top10ScannedSerialNumberPieChart.vue?vue&type=template&id=204e2e72&scoped=true"
import script from "./Top10ScannedSerialNumberPieChart.vue?vue&type=script&lang=js"
export * from "./Top10ScannedSerialNumberPieChart.vue?vue&type=script&lang=js"
import style0 from "./Top10ScannedSerialNumberPieChart.vue?vue&type=style&index=0&id=204e2e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e2e72",
  null
  
)

export default component.exports